export default "__VITE_ASSET__9wI9JAhx__"